import Modal from "../../../../../commons/Modal/Modal"
import { ModalProps } from "../../../../../commons/Modal/Modal.types"
import CreateProspectDIRForm from "./CreateProspectDIRForm/CreateProspectDIRForm"

export default ({ ...props }: ModalProps) => {
  return (
    <Modal {...props} closeOnClickOutside>
      <CreateProspectDIRForm />
    </Modal>
  )
}